import { useMemo } from "react";
import DetailsModal from ".";
import { useVisible } from "../../../../utils/hooks/useVisible"

export const useDetailsModal = () => {
    const { open, close, selected, visible } = useVisible();

    const modal = useMemo(() => {
        return (
            <DetailsModal
                visible={visible}
                selected={selected}
                close={close}
            />
        );
    }, [close, selected, visible]);

    return { open, modal };
}